import { render, staticRenderFns } from "./section-results-info.vue?vue&type=template&id=be6ff632&scoped=true&"
import script from "./section-results-info.vue?vue&type=script&lang=js&"
export * from "./section-results-info.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  
}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "be6ff632",
  null
  ,true
)

export default component.exports